import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../../components/Picture/Picture';
import profile_default from '../../../images/Homepage/DiscoverV3/profile_default.svg';
import { useCurrentUser, useLogout } from '../../../hooks';
import { OverflowMenu } from '../../../components';

import classNames from 'classnames/bind';
import styles from '../../../styles/main.module.scss';

const cx = classNames.bind(styles);

const UserMenu = () => {
  const { currentUser } = useCurrentUser();
  const { picture = '' } = currentUser || {};

  const { logoutAndRefetch } = useLogout();

  let image;
  if (picture) {
    image = <Picture src={picture} alt="profile pic" className={cx('profile-img')} />;
  } else {
    image = <img src={profile_default} alt="profile pic" className={cx('profile-img')} />;
  }

  return (
    <OverflowMenu
      options={[
        ...(currentUser
          ? [
              {
                label: 'Log Out',
                onClick: logoutAndRefetch,
              },
            ]
          : [
              {
                label: 'Log In',
                to: '/login',
              },
              {
                label: 'Sign Up',
                to: '/signup/app',
              },
            ]),
      ]}
      position="bottomLeft"
      buttonType="gear"
      largeDots
      menuStyle={{ minWidth: '140px', textAlign: 'right' }}
      CustomButton={image}
    />
  );
};

UserMenu.propTypes = {
  isAuthenticated: PropTypes.bool,
};

UserMenu.defaultProps = {
  isAuthenticated: false,
};

export default UserMenu;
